import FirmApi from '../../services/FirmApi'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { crmService, CrmProduktInformaceInterface } from '@/services/CrmService'

interface PresentationInterface {
    id: number
    name: string
    price_per_year: number //DEPECATED - nepouziva se, nacita se vzdz aktualni cena
    active: number
    services: string
    button_value: string
}

@Module({ namespaced: true })
export class presentations extends VuexModule {
    public presentations: Array<PresentationInterface> = []
    public cena_bez_dph__placeny_zapis: number = 0

    @Mutation
    public setPresentations(payload: Array<PresentationInterface>) {
        this.presentations = payload
    }

    @Mutation
    public setCenaBezDphPlacenyZapis(cena_bez_dph__placeny_zapis: number) {
        this.cena_bez_dph__placeny_zapis = cena_bez_dph__placeny_zapis
    }

    @Action
    public updatePresentations(payload: Array<PresentationInterface>) {
        this.context.commit('setPresentations', payload)
    }
    @Action
    public async fetchPresentations() {
        this.context.dispatch('loader/setLoader', 'Načítám prezentace ...', {
            root: true,
        })
        let response = await FirmApi.fetchPresentations(
            this.context.rootState.config.crm
        )
        // if (response.status !== 200) {
        //     console.log(response.statusText)
        //     await this.context.dispatch('loader/setError', response.statusText, {
        //         root: true,
        //     })
        //     return
        // }
        // console.log(response)
        const { results } = response.data
        const fetchedPresentations: Array<PresentationInterface> = response.data.results
        // console.log(results)

        // Katalog firem: přednostní zápis
        response = await crmService.getProduktInformace(121)
        let crmProduktInformaceInterface: CrmProduktInformaceInterface =
            response.data.produkt_informace
        console.log(crmProduktInformaceInterface, 'crmProduktInformaceInterface')

        const cena_bez_dph__kf_prednostni_zapis_za_mesic =
            crmProduktInformaceInterface.cena_bez_dph

        console.log(
            cena_bez_dph__kf_prednostni_zapis_za_mesic,
            'cena_bez_dph__kf_prednostni_zapis_za_mesic'
        )

        // Karta firmy
        response = await crmService.getProduktInformace(3)
        crmProduktInformaceInterface =
            response.data.produkt_informace
        console.log(crmProduktInformaceInterface, 'crmProduktInformaceInterface')

        const cena_bez_dph__karta_firmy_za_mesic =
            crmProduktInformaceInterface.cena_bez_dph

        console.log(
            cena_bez_dph__karta_firmy_za_mesic,
            'cena_bez_dph__karta_firmy_za_mesic'
        )

        let cena_bez_dph__placeny_zapis = (12 * cena_bez_dph__karta_firmy_za_mesic) + (12 * cena_bez_dph__karta_firmy_za_mesic)
        cena_bez_dph__placeny_zapis = cena_bez_dph__placeny_zapis * 0.50 // 50% sleva

        console.log(
            cena_bez_dph__placeny_zapis,
            'cena_bez_dp__placeny_zapis'
        )
        this.context.commit('setCenaBezDphPlacenyZapis', cena_bez_dph__placeny_zapis)

        if (cena_bez_dph__placeny_zapis === 0) {
            await this.context.dispatch('loader/setLoader', 'Nepodařilo se zjistit aktuální cenu služby, vraťte se o krok zpět a zkuste pokračovat.', { root: true })
            return
        }

        // prepise aktualni cenu za rok bez dph
        if (fetchedPresentations[1].id === 2) {
            fetchedPresentations[1].price_per_year = cena_bez_dph__placeny_zapis
        }


        this.context.commit('setPresentations', fetchedPresentations)
        await this.context.dispatch('loader/setLoader', '', { root: true })
    }

    get cenaBezDphPlacenyZapis(): number {
        return this.cena_bez_dph__placeny_zapis
    }
}
